



























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import ImageInfo from '../../AiiTasks/ImageInfo.vue'
import Tabs from '@/views/mediate/Tabs.vue'
import OtherInvestigateTabs from '@/views/other/Tabs.vue'
import SuperTabs from '@/views/AiiTasks/SuperTabs.vue'
import bus from '../../AiiTasks/bus'
import { initOrderDetail } from '@/web-task/utils/order'
import Task from '@/web-task'
import Info from '@/views/AiiTasks/Info.vue'
import TaskLog from './taskLog.vue'
import PartnerRecord from './partnerRecord.vue'
import { getTaskType } from '@/utils/order'
import { wsURL } from '@/api/url'
import {
	QU_XIAO_ZHONG_CHU_SHEN,
	DAI_CHU_SHEN,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
} from '@/web-task/config.ts'
const processArr = [
	{
		title: '基本信息',
		backendKey: 'baseInfo',
	},
	{
		title: '社会关系',
		backendKey: 'relation',
	},
	{
		title: '影像信息',
		backendKey: 'media',
	},
	{
		title: '调解协议',
		backendKey: 'conciliation',
	},
]

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'partnerOrderDetail',
	components: {
		PageLayout,
		ImageInfo,
		SuperTabs,
		Info,
		Tabs,
		TaskLog,
		PartnerRecord,
		OtherInvestigateTabs,
	},
})
export default class QueryList extends Vue {
	//兼容第三方平台跳转详情
	@Prop() private CanChecked?: any
	@Prop() private OrderId?: any
	@Prop() private DispatchId?: any
	private orderId: any = ''
	private dispatchId: any = ''
	private cs = false

	private addResurveyVisible: boolean = false
	private order: any = ''
	private injured: any = ''
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private returnForm: any = {}
	private mediaOrder: any = []
	private mediaMap: any = {}
	private mediaInfoMap: any = {}
	private ws: any = ''
	private activeKey: any = '1'
	private timer: any = ''
	private expireTimer: any = ''
	private throttleOpenWS = throttle(10 * 1000)
	private once: boolean = false
	private exporting: boolean = false
	private visitorPhone: any = ''
	private cancelLoading: boolean = false
	private revokeDialogVisible: boolean = false
	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private evaluateForm: any = {}
	private evaluateVisible: boolean = false
	private evaluateLoading: boolean = false
	private rate: number = 5
	private labelMap: any = {}
	private labelList: any = []
	private evaluateInfo: any = {}
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private show: any = ''
	private visitorPopupShow: boolean = false
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	private lastOrderInfo: any = ''
	private addForm: any = {}
	private taskInfo: any = {}
	private task: any = {}
	private addLoading: boolean = false
	private QU_XIAO_ZHONG_CHU_SHEN = QU_XIAO_ZHONG_CHU_SHEN
	private DAI_CHU_SHEN = DAI_CHU_SHEN
	private DAI_ZHONG_SHEN = DAI_ZHONG_SHEN
	private YI_WAN_CHENG = YI_WAN_CHENG
	private processArr = processArr

	private visiblePass: boolean = false
	private passForm: any = {}
	get isFromThird() {
		return !!this.OrderId
	}
	private tabs: any = {
		index: '1',
		items: [
			{
				key: '1',
				title: '基本信息',
			},
			{
				key: '2',
				title: '影像信息',
			},
		],
		active: () => {
			return this.tabs.index
		},
		callback: (key: any) => {
			this.tabs.index = key
		},
	}
	@Watch('$route', { immediate: true })
	private onRouteChange(route: any) {
		this.orderId = this.$route.params.orderId //兼容第三方平台跳转详情
		this.dispatchId = this.$route.params.dispatchId //兼容第三方平台跳转详情
	}

	@Watch('order', { immediate: true })
	private onOrderChange() {
		if (this.canChecked && this.order) {
			this.task = new Task({
				propsData: {
					order: this.order,
					injured: this.injured,
					setting: this.$store.state.setting,
				},
			})
		}
		if (!this.canChecked) {
			const task: any = new Task({
				propsData: {
					order: this.order,
					injured: this.injured,
					setting: this.$store.state.setting,
				},
				methods: {
					getParnterTaskInfo() {
						const that: any = this
						const res = that.checkParams()
						if (!res) {
							return
						}
						const { order, setting } = that

						let arr: any = [
							{
								label: '派单公司',
								value: order.companyName,
							},
							{
								label: '订单号',
								value: order.orderNo,
							},
							{
								label: '报案号',
								value: order.caseNo,
							},
							{
								label: '所属险种',
								value: setting.insuranceTypeMap[order.insuranceType],
							},
							{
								label: '任务类型',
								value: getTaskType(order, setting),
							},
						]
						if (that.isFirstVisit || (that.isResurvey && that.isCarInsurance)) {
							arr = arr.concat([
								{
									label: '车主/报案人姓名',
									value: order.ownerName,
								},
							])
						}
						if (!that.isMediate && !that.isOtherInvestigate) {
							arr.push({
								label: '伤者姓名',
								value: order.injuredName,
							})
						}
						if (that.isLivingInvestigate || that.isOtherInvestigate) {
							arr = arr.concat([
								{
									label: '调查所在地区',
									value: order.clinicArea,
								},
								{
									label: '详细地址',
									value: order.address,
								},
							])
						} else if (that.isWorkInvestigate) {
							arr = arr.concat([
								{
									label: '公司所在地',
									value: order.clinicArea,
								},
								{
									label: '调查公司名称',
									value: order.injuredCompany,
								},
								{
									label: '公司详细地址',
									value: order.address,
								},
							])
						} else if (that.isMediate) {
							arr = arr.concat([
								{
									label: '调解所在地区',
									value: order.clinicArea,
								},
							])
						} else {
							arr = arr.concat([
								{
									label:
										that.isMotionAtHome || that.isHomeInvestigate
											? '伤者居住所在区域'
											: '就诊地区',
									value: order.clinicArea,
								},
								{
									label:
										that.isMotionAtHome || that.isHomeInvestigate
											? '伤者居住地详细地址'
											: '就诊医院',
									value: that.isHomeInvestigate
										? order.address
										: order.hospital,
								},
							])
						}

						if (
							that.isFirstVisit ||
							that.isResurvey ||
							that.isMotionInHospital
						) {
							arr.push({
								label: '所在科室',
								value: order.department,
							})
						}
						arr = arr.concat([
							{
								label: '案件负责人姓名',
								value: order.contact,
							},
							{
								label: '案件负责人电话',
								value: order.contactPhone,
							},
						])

						arr.push({
							label: '任务要求',
							value: order.conciliationRequire || order.visitRequest,
						})

						return {
							title: '任务信息',
							children: arr,
							span: {
								报案号: 12,
							},
						}
					},
				},
			})
			this.task = task
			this.taskInfo = task.getParnterTaskInfo()
		}
	}

	private back() {
		this.$router.go(-1)
	}

	private get canChecked() {
		return (
			this.$route.params.canChecked === '1' ||
			this.$route.params.canChecked === '2' ||
			this.CanChecked === '1'
		)
	}

	private insufficiencyChange(e: any) {
		this.passForm.insufficiency = e.target.value
	}

	private getEvaluate() {
		return EvaluateApi.getEvaluate({
			businessId: this.orderId,
			evType: 'insurance',
		}).then((res: any) => {
			this.labelList = []
			this.labelMap = {}
			this.rate = 5
			this.evaluateForm.resetFields()
			if (res.data[0]) {
				this.evaluateInfo = res.data[0]
				this.labelList = res.data[0].labels
			}
		})
	}

	private handleCancel() {
		this.visiblePass = false
	}
	private handleOk() {
		this.passForm.validateFields((err: any, values: any) => {
			if (!err) {
				console.log(values, 'passForm')
				TaskApi.checkTask({
					orderId: this.orderId,
					pass: '1',
					insufficiency: values.insufficiency,
					insufficiencyRemark: values.insufficiencyRemark,
				}).then((res: any) => {
					// this.getDetail()
					this.visiblePass = false
					this.$message.success('审核通过成功')
					setTimeout(() => {
						this.$router.replace('/partner/order/orderList')
					}, 1000)
				})
			}
		})
	}
	private chcekPass() {
		if (this.order.insufficiency != '1') {
			this.visiblePass = true
		} else {
			this.$confirm({
				title: '提示',
				content: '确认审核通过吗 ?',
				onOk: () => {
					return TaskApi.checkTask({
						orderId: this.orderId,
						pass: '1',
					}).then((res: any) => {
						// this.getDetail()
						this.$message.success('审核通过成功')
						setTimeout(() => {
							this.$router.replace('/partner/order/orderList')
						}, 1000)
					})
				},
			})
		}
	}

	private chcekInsufficiency() {
		this.$confirm({
			title: '提示',
			content: '确认资料已补充 ?',
			onOk: () => {
				return TaskApi.sufficiency({
					orderId: this.orderId,
				}).then((res: any) => {
					this.getDetail()
					this.$message.success('资料已补充成功')
					// setTimeout(() => {
					// 	this.$router.replace('/partner/order/orderList')
					// }, 1000)
				})
			},
		})
	}

	private auditCancelPass() {
		let operatorArrived = false
		if (this.order.applyCancels && this.order.applyCancels.length) {
			const apply = this.order.applyCancels.find(
				(item: any) => item.dataType === 'application'
			)

			operatorArrived = apply.type === '2'
		}
		const obj: any = {
			title: '提示',
			content: `确认同意撤单吗 ?`,
			onOk: () => {
				return TaskApi.checkCancelInfo({
					orderId: this.orderId,
					pass: 1,
				}).then((res: any) => {
					this.$message.success('撤单申请已同意')
					setTimeout(() => {
						if (this.$route.params.canChecked === '2') {
							this.$router.push(`/returnVisit/auditList`)
						} else {
							this.$router.replace('/partner/order/orderList')
						}
					}, 1000)
				})
			},
		}

		if (operatorArrived) {
			obj.content = (h: any) => {
				return h('div', {}, [
					h('div', '确认同意撤单吗 ?'),
					h(
						'div',
						{
							style: {
								color: '#E02020',
								marginTop: '6px',
							},
						},
						`注：因作业人员已到达作业地点，请认真审核撤单提交的资料是否属实，如撤单成功该任务会产生相应的费用！`
					),
				])
			}
		}

		this.$confirm(obj)
	}

	private auditCancelReject() {
		this.auditCancelVisible = true
		this.auditCancelForm.resetFields()
	}

	// 拒绝撤单申请
	private deAuditCancel() {
		this.auditCancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.auditCancelLoading = true
				const copy = {
					...values,
					orderId: this.orderId,
					pass: 0,
				}
				TaskApi.checkCancelInfo(copy)
					.then((res: any) => {
						this.$message.success('撤单申请已拒绝')
						this.auditCancelVisible = false
						setTimeout(() => {
							console.log(this.$route.params.canChecked)
							if (this.$route.params.canChecked === '2') {
								console.log('123')
								this.$router.push(`/returnVisit/auditList`)
							} else {
								console.log('147')
								this.$router.replace('/partner/order/orderList')
							}
						}, 1000)
					})
					.finally(() => {
						this.auditCancelLoading = false
					})
			}
		})
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.show = ''
		this.tabs.index = '1'
		this.ws && this.ws.close()
		this.$nextTick(() => {
			this.getInitData()
		})
		next()
	}

	private choose(i: any) {
		this.rate = i
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private evaluateOrder() {
		const id = this.evaluateInfo.id
		EvaluateApi.saveEvaluate({
			id,
			userId: this.$store.state.user.userInfo.userId,
			urerName: this.$store.state.user.userInfo.userName,
			score: this.rate,
			comment: this.evaluateForm.getFieldValue('comment'),
			labels: this.labelList
				.map((item: any) => item.id)
				.filter((item: any) => this.labelMap[item]),
		}).then((res: any) => {
			this.$message.success('评价完成')
			this.evaluateVisible = false
			this.getEvaluate()
		})
	}

	private mounted() {
		this.visitorPopupShow = true
	}

	private soFarDate(date: any) {
		if (date) {
			if (date < SO_FAR) {
				return moment(this.injured.injuredInfo.leaveDate).format('YYYY-MM-DD')
			} else {
				return '至今'
			}
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private getDetail() {
		return PartnerApi.getOrder({
			dispatchId: this.dispatchId,
		}).then((res: any) => {
			this.order = res.data
			this.order.endEffectTime = moment(this.order.endEffectTime).format(
				'YYYY-MM-DD HH:mm:ss'
			)
		})
	}

	private getFullDetail() {
		return PartnerApi.getFullOrder(this.orderId).then((data: any) => {
			this.injured = initOrderDetail(data.data)
			this.order = data.data.order
		})
	}

	private created() {
		this.returnForm = this.$form.createForm(this)
		this.addForm = this.$form.createForm(this)
		this.cancelForm = this.$form.createForm(this)
		this.evaluateForm = this.$form.createForm(this)
		this.auditCancelForm = this.$form.createForm(this)
		this.passForm = this.$form.createForm(this)
		this.orderId = this.$route.params.orderId || this.OrderId //兼容第三方平台跳转详情
		this.dispatchId = this.$route.params.dispatchId || this.DispatchId //兼容第三方平台跳转详情
		this.cs = this.$route.params.dispatchId || this.DispatchId
		this.getInitData()
	}
	private deactivated() {
		this.show = ''
		this.tabs.index = '1'
		this.ws && this.ws.close()
	}

	private openWS() {
		if (!this.order.orderNo) {
			return
		}
		TaskApi.getMsgToken(this.order.orderNo).then((res: any) => {
			if (res.code !== 200) {
				return
			}
			const msgToken = res.data
			const ws = new WebSocket(wsURL)
			this.ws = ws
			ws.onmessage = (event: any) => {
				try {
					const data: any = JSON.parse(event.data)
					if (data.content) {
						const content: any = JSON.parse(JSON.parse(data.content))
						if (content.status && content.status !== this.order.orderStatus) {
							this.getDetail()
						}
					}
				} catch (e) {
					//
				}
			}
			ws.onopen = () => {
				ws.send(
					JSON.stringify({
						requestId: uuid(),
						requestTime: moment().format('YYYY-MM-DD HH:mm:ss'),
						version: 'V1.0',
						data: {
							msgToken,
						},
					})
				)
				this.timer = setInterval(() => {
					ws.send('ping')
				}, 9 * 1000)
				this.expireTimer = setTimeout(() => {
					TaskApi.expireToken(this.order.orderNo)
				}, 29 * 60 * 1000)
			}
			ws.onclose = () => {
				clearTimeout(this.timer)
				clearTimeout(this.expireTimer)
				if (this.$route.name === 'AiiTaskDetail' && this.order.orderStatus) {
					this.throttleOpenWS(this.openWS)
				}
			}
		})
	}

	private async getInitData() {
		this.order = ''
		this.injured = ''
		if (this.canChecked) {
			await this.getFullDetail()
			this.openWS()
		} else {
			this.getDetail()
		}
		// console.log(
		// 	'orderId:',
		// 	this.orderId,
		// 	'dispatchId:',
		// 	this.dispatchId,
		// 	'CanChecked:',
		// 	this.canChecked
		// )
	}

	private activated() {
		this.getInitData()
	}

	private onTabsChange(activeKey: string) {
		this.activeKey = activeKey
		window.scrollTo(0, 0)
	}

	private auditTaskPass() {
		const order = this.order
		this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				return TaskApi.auditTask({
					id: order.operationId,
					orderId: this.orderId,
					status: '04',
					orderStatus: '05',
				}).then((res: any) => {
					this.getDetail()
					this.getEvaluate().then(() => {
						if (this.evaluateInfo.evStatus === '0') {
							this.evaluateVisible = true
						}
					})
				})
			},
		})
	}

	private auditTaskReturn() {
		this.returnForm.resetFields()
		this.returnVisible = true
	}

	private returnOk() {
		this.returnForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.returnLoading = true
				if (this.order.orderStatus === '04') {
					TaskApi.auditTask({
						id: this.order.operationId,
						orderId: this.orderId,
						status: '01',
						orderStatus: '02',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.$message.success('审核退回成功')
							setTimeout(() => {
								this.$router.replace('/partner/order/orderList')
							}, 1000)
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '031') {
					TaskApi.checkTask({
						orderId: this.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.$message.success('审核退回成功')
							setTimeout(() => {
								this.$router.replace('/partner/order/orderList')
							}, 1000)
						})
						.finally(() => {
							this.returnLoading = false
						})
				}
			}
		})
	}
}
